/* Mixed-bundle "What's inside" quick-view modal.
 *
 * Loaded once on the bundle PDP (outside the slot that is injected via
 * innerHTML), and uses document-level event delegation — so it works even
 * though the modal markup and trigger cards are injected into the page after
 * load. Clicking a product name / "More info" lazy-loads that product's
 * details from /products/<handle>?view=bundle-info and shows them in a sheet.
 */
(function () {
  'use strict';

  if (window.__productInfoModalInit) return;
  window.__productInfoModalInit = true;

  var openRoot = null;
  var lastFocused = null;
  var cache = {};

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  function hydrate(container) {
    // Accordions are Alpine components — initialise the injected subtree.
    if (window.Alpine && typeof window.Alpine.initTree === 'function') {
      try { window.Alpine.initTree(container); } catch (e) {}
    }
  }

  /* Ingredients + Nutrition tables.
   *
   * On the PDP these are populated by snippets/ingredient-table.liquid (a
   * <script> rendered inside the accordion). That script does not run in the
   * modal (innerHTML doesn't execute scripts) and uses a global querySelector,
   * so we re-implement the fetch + render here, SCOPED to the modal body, for
   * the product the modal was opened with. Keep in sync with
   * snippets/ingredient-table.liquid (same Supabase endpoints + markup).
   */
  var TABLES_FN_BASE = 'https://dqzbhpncromswzjzginu.supabase.co/functions/v1/';
  var CELL = 'border:1px solid #ddd; padding:10px 12px;';
  var TABLE_OPEN =
    '<table style="width:100%; margin-bottom:2rem; font-family:sans-serif; font-size:14px;' +
    ' table-layout:fixed; border:1px solid #ddd; border-collapse:collapse;">' +
    '<colgroup><col style="width:50%;"><col style="width:25%;"><col style="width:25%;"></colgroup>';

  function fetchGlowTable(fn, handle, country) {
    var url = new URL(TABLES_FN_BASE + fn);
    url.searchParams.set('handle', handle);
    url.searchParams.set('country', country);
    return fetch(url.toString())
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { return j.data || []; })
      .catch(function () { return []; });
  }

  function labelCell(row, accent) {
    var style = CELL + ' text-align:left;' +
      (row.is_bold ? ' font-weight:600;' : '') +
      (row.is_indent ? ' padding-left:32px; color:#666; font-style:italic;' : '');
    return '<td style="' + style + '">' + (row.label || '—') + '</td>';
  }

  function ingredientsTableHTML(data) {
    var rows = data.map(function (row, i) {
      return '<tr style="background-color:' + (i % 2 === 0 ? '#EDE7DF' : '#f4f1eb') + ';">' +
        labelCell(row) +
        '<td style="' + CELL + ' text-align:right; font-weight:500;">' + (row.value_per_serving || '—') + '</td>' +
        '<td style="' + CELL + ' text-align:right; font-weight:500; color:#888;">' + (row.value_per_100g || '—') + '</td>' +
        '</tr>';
    }).join('');
    return TABLE_OPEN +
      '<thead><tr style="background-color:#f4f1eb;">' +
      '<th style="' + CELL + ' text-align:left; font-weight:600;">Ingredient</th>' +
      '<th style="' + CELL + ' text-align:right; font-weight:600;">Per Serving</th>' +
      '<th style="' + CELL + ' text-align:right; font-weight:600;">Per 100g</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table>';
  }

  function nutritionTableHTML(data) {
    var rows = data.map(function (row, i) {
      var nrv = row.nrv === '**' ? '<strong>**</strong>' : (row.nrv || '');
      return '<tr style="background-color:' + (i % 2 === 0 ? '#EDE7DF' : '#f4f1eb') + ';">' +
        labelCell(row) +
        '<td style="' + CELL + ' text-align:right; font-weight:500;">' + (row.value_per_serving || '—') + '</td>' +
        '<td style="' + CELL + ' text-align:right; font-weight:500; color:#2c3e50;">' + nrv + '</td>' +
        '</tr>';
    }).join('');
    return TABLE_OPEN +
      '<thead><tr style="background-color:#f4f1eb;">' +
      '<th style="' + CELL + ' text-align:left; font-weight:600;">Nutrient</th>' +
      '<th style="' + CELL + ' text-align:right; font-weight:600;">Per Serving</th>' +
      '<th style="' + CELL + ' text-align:right; font-weight:600;">% NRV*</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table>' +
      '<div style="font-size:11px; color:#777; text-align:center; margin-top:8px; font-style:italic;">' +
      '* % Nutrient Reference Value (NRV) • ** Significant source (no official NRV)</div>';
  }

  function renderProductTables(scope, handle) {
    var country = (window.Shopify && window.Shopify.country) || 'DE';
    var ing = scope.querySelector('.glow-ingredient-table');
    var nut = scope.querySelector('.glow-nutrition-table');
    if (ing) {
      fetchGlowTable('glow-ingredients', handle, country).then(function (data) {
        if (data.length) ing.innerHTML = ingredientsTableHTML(data);
      });
    }
    if (nut) {
      fetchGlowTable('glow-nutrition', handle, country).then(function (data) {
        if (data.length) nut.innerHTML = nutritionTableHTML(data);
      });
    }
  }

  function openModal(root, handle) {
    var modal = root.querySelector('[data-product-info-modal]');
    var sheet = root.querySelector('[data-product-info-sheet]');
    var body = root.querySelector('[data-product-info-body]');
    var base = root.getAttribute('data-products-base');
    // A base of "//products/" (routes.root_url = "/" on unprefixed markets) is
    // protocol-relative and unfetchable — collapse it back to a path.
    if (base && base.indexOf('//') === 0) base = base.slice(1);
    if (!modal || !body) return;

    openRoot = root;
    lastFocused = document.activeElement;
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    lockScroll(true);
    var closeBtn = modal.querySelector('[data-product-info-close-btn]');
    if (closeBtn) closeBtn.focus();

    function inject(html) {
      body.innerHTML = html;
      if (sheet) sheet.scrollTop = 0;
      hydrate(body);
      renderProductTables(body, handle);
    }

    if (cache[handle]) { inject(cache[handle]); return; }
    body.innerHTML = '<div class="product-info-modal__loading"><span class="product-info-modal__spinner" aria-hidden="true"></span></div>';
    fetch(base + handle + '?view=bundle-info')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { cache[handle] = html; inject(html); })
      .catch(function () {
        var label = root.getAttribute('data-product-info-full-label') || 'View product';
        body.innerHTML = '<div class="product-info-modal__error"><a href="' + base + handle +
          '" target="_blank" rel="noopener">' + label + '</a></div>';
      });
  }

  function closeModal(root) {
    var modal = root.querySelector('[data-product-info-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    lockScroll(false);
    var done = function () {
      if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', '');
      modal.removeEventListener('transitionend', done);
    };
    modal.addEventListener('transitionend', done);
    setTimeout(done, 400);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    openRoot = null;
  }

  function triggerFrom(target) {
    return target && target.closest ? target.closest('[data-product-info-trigger]') : null;
  }

  document.addEventListener('click', function (e) {
    var trigger = triggerFrom(e.target);
    if (trigger) {
      e.preventDefault();
      var root = trigger.closest('[data-product-info-root]');
      var handle = trigger.getAttribute('data-handle');
      if (root && handle) openModal(root, handle);
      return;
    }
    var closer = e.target.closest ? e.target.closest('[data-product-info-close]') : null;
    if (closer) {
      var r = closer.closest('[data-product-info-root]');
      if (r) closeModal(r);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openRoot) { closeModal(openRoot); return; }
    if (e.key === 'Enter' || e.key === ' ') {
      var trigger = triggerFrom(e.target);
      if (trigger && trigger.tagName === 'SPAN') {
        e.preventDefault();
        var root = trigger.closest('[data-product-info-root]');
        var handle = trigger.getAttribute('data-handle');
        if (root && handle) openModal(root, handle);
      }
    }
  });
})();
